export default __webpack_public_path__ + "static/media/application-have-idea-500.a274bd81.png";